export default __webpack_public_path__ + "static/media/chatBaloon.6cac0c18.svg";